module.exports = __webpack_public_path__ + "img/Spotify_Icon_RGB_Black.b818d523.png";